import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import trailing_45slash_45global from "/opt/buildhome/repo/node_modules/.c12/github_onderwijsin_onderwijsloket_sJh5Cv9YiK/middleware/trailingSlash.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}